module.exports = __webpack_public_path__ + "static/media/lottery_success.42f9e4d5.png";